import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { API, DEFAULT_CONTENT, deepMerge } from "@/lib/content";

const ContentContext = createContext({ content: DEFAULT_CONTENT });

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(DEFAULT_CONTENT);

  useEffect(() => {
    const isPreview = new URLSearchParams(window.location.search).get("preview") === "1";
    const request = isPreview
      ? axios.get(`${API}/admin/draft`, { withCredentials: true }).then((r) => r.data.content)
      : axios.get(`${API}/content`).then((r) => r.data);
    request
      .then((data) => setContent(deepMerge(DEFAULT_CONTENT, data)))
      .catch(() => {});
  }, []);

  useEffect(() => {
    const favicon = content.business?.favicon_url;
    if (favicon) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.href = favicon;
    }
  }, [content]);

  return (
    <ContentContext.Provider value={{ content }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => useContext(ContentContext);
